'use client'

import { Box, Flex } from '@mantine/core'
import { RebrandSearchIcon } from '@/components/Icons/Rebrand/SearchIcon'
import type { SearchTermSuggestion } from './universalSearchTypes'
import classes from './UniversalSearch.module.css'

interface SearchTermSuggestionRowProps {
    /** Suggestion to display (label shown in the row, query used on select). */
    suggestion: SearchTermSuggestion
    /** Called when the user taps this row. */
    onSelect: (suggestion: SearchTermSuggestion) => void
    /** Use mobile for the larger thumbnail and mobile panel row layout. */
    variant?: 'default' | 'mobile'
}

/** One suggestion row, such as "Dermatology" or "GLP-1". */
export function SearchTermSuggestionRow({ suggestion, onSelect, variant = 'default' }: SearchTermSuggestionRowProps) {
    const isMobileVariant = variant === 'mobile'
    const iconSize = isMobileVariant ? 20 : 16
    const iconClassName = isMobileVariant ? classes.suggestionIconMobile : classes.suggestionIcon

    return (
        <button
            type="button"
            className={[classes.suggestionRow, isMobileVariant ? classes.suggestionRowMobile : '']
                .filter(Boolean)
                .join(' ')}
            onClick={() => onSelect(suggestion)}
        >
            <Box className={iconClassName} aria-hidden>
                <Flex align="center" justify="center" w="100%" h="100%">
                    <RebrandSearchIcon width={iconSize} height={iconSize} className={classes.rowIcon} />
                </Flex>
            </Box>
            <span className={classes.suggestionRowTitle}>{suggestion.label}</span>
        </button>
    )
}
